document.addEventListener("DOMContentLoaded", function () {
    console.log("Loaded Script");
    console.log("Carousel items are: ")
    let carouselItems = document.querySelectorAll('.information-carousel-list li');
    let currentItem = 0;
    let timeoutCounter = 4000 // time in ms
  
    function showNextItem() {    
      if (carouselItems[currentItem].classList.contains('active')) {
        carouselItems[currentItem].classList.remove('active');      
      }
      
      currentItem = (currentItem + 1) % carouselItems.length;
      
      // Ensure the item is visible before adding the active class for animation
      carouselItems[currentItem].style.display = 'flex';
      setTimeout(() => carouselItems[currentItem].classList.add('active'), 100);    
      // carouselItems[currentItem].classList.add('active');
      setTimeout(showNextItem, timeoutCounter); // Change item every 500ms
    }
  
    // Start the cycle
    setTimeout(showNextItem, 500);  
  });
